import React, { useRef, useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { Input, InputAdornment, Box } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { makeStyles } from "@material-ui/styles";
import MomentUtils from "@date-io/moment";

import { CalendarIcon } from "../icons";
import PopoverStyles from "../styles/popover";

const useStyles = makeStyles(() => ({
  calendar: {
    fontSize: "0.75rem",
    width: "5.688rem",
    color: "white",
    cursor: "default",

    "& input": {
      cursor: "default",
    },
  },
  icon: {
    cursor: "pointer",
  },
}));

const Calendar = ({
  value,
  onChange,
  handleOpen,
  handleClose,
  handleOnLoad,
  ...rest
}) => {
  const styles = useStyles();
  const boxRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    open && handleOnLoad && handleOnLoad();
  }, [open, handleOnLoad]);

  const onDateChange = useCallback(
    (date) => {
      !date.isSame(value) && onChange(date);
    },
    [onChange, value]
  );

  const handleOnClick = useCallback(() => {
    setOpen(!open);
    handleOpen && handleOpen();
  }, [handleOpen, open]);

  const handleOnClose = useCallback(() => {
    setOpen(false);
    handleClose && handleClose();
  }, [handleClose]);

  return (
    <Box ref={boxRef}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <DatePicker
          value={value}
          onChange={onDateChange}
          variant="inline"
          format="DD/MM/YYYY"
          autoOk
          readOnly
          onClose={handleOnClose}
          open={open}
          {...rest}
          PopoverProps={{
            ...PopoverStyles,
            anchorEl: boxRef.current,
          }}
          TextFieldComponent={({ value, error, readOnly, format }) => (
            <Input
              inputProps={{
                "data-testid": "calendar-input-value",
              }}
              value={value}
              readOnly={readOnly}
              format={format}
              error={error}
              disableUnderline
              className={styles.calendar}
              endAdornment={
                <InputAdornment
                  className={styles.icon}
                  position="end"
                  data-testid="calendar-icon"
                  onClick={handleOnClick}
                >
                  <CalendarIcon />
                </InputAdornment>
              }
            />
          )}
        />
      </MuiPickersUtilsProvider>
    </Box>
  );
};

Calendar.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
};

export default Calendar;
